import { CdkDrag, CdkDragMove, CdkDropList, CdkDropListGroup, DropListRef } from '@angular/cdk/drag-drop';
import { ViewportRuler } from '@angular/cdk/overlay';
import { Component, ContentChildren, EventEmitter, Input, Output, QueryList, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { GridItemDirective } from '../gridItem/gridItem.directive';


enum ResizeType {
  SWAP,
  REDUCE,
  ENLARGE,
}

@Component({
  selector: 'stats-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})

export class StatsGridComponent {
  @Input() resize: Observable<boolean[]>;
  @Output() moved = new EventEmitter<{ sourceIdx: number, targetIdx: number}>();
  @Output() resized = new EventEmitter<{idx: number, enlarged: boolean}>();
  @Output() closed = new EventEmitter<number>();
  @ContentChildren(GridItemDirective) gridItems: QueryList<GridItemDirective>;
  //@ContentChildren(CdkDropList) dropLists: QueryList<CdkDropList>;
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;

  ResizeType: typeof ResizeType = ResizeType;

  public target: CdkDropList = null;
  public targetIndex: number;
  public source: CdkDropList = null;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer = null;

  bypassEnterCheck: boolean = false;
  resizeTable: string[];
  isDisabled: boolean = false;

  private resizeSub: any;

  constructor(private viewportRuler: ViewportRuler) { }

  ngOnInit() {
    this.resizeSub = this.resize.subscribe(table => {
      this.resizeTable = []
      for (let i = 0; i < table.length; i++)
        this.resizeTable.push(table[i] ? "graph-enlarged" : "graph-reduced");
    });
  }

  ngAfterViewInit() {
    // Récupération du placeholder
    let phElement = this.placeholder.element.nativeElement;

    // Masquage de celui-ci
    phElement.style.display = 'none';

    // Dé-association de son parent
    phElement.parentElement.removeChild(phElement);
  }

  ngOnDestroy() {
    this.resizeSub.unsubscribe();
  }

  resizeItem(idx: number, type: ResizeType) {
    let element: HTMLElement = document.getElementById("graph-" + idx);

    let isEnlarge: boolean = (type == ResizeType.ENLARGE) ? true : ((type == ResizeType.REDUCE) ? false : (this.resizeTable[idx] == "graph-reduced"));

    if (isEnlarge) {
      element.classList.remove("graph-reduced");
      element.classList.add("graph-enlarged");
      (element.firstChild as HTMLElement).classList.remove("graph-reduced-container");
      (element.firstChild as HTMLElement).classList.add("graph-enlarged-container");
    }
    else {
      element.classList.remove("graph-enlarged");
      element.classList.add("graph-reduced");
      (element.firstChild as HTMLElement).classList.remove("graph-enlarged-container");
      (element.firstChild as HTMLElement).classList.add("graph-reduced-container");
    }

    this.resized.emit({ idx: idx, enlarged: isEnlarge });
  }

  closeItem(idx: number) {
    this.closed.emit(idx);
  }

  drop() {
    // Si pas de cible, annulation
    if (!this.target)
      return;

    let phElement = this.placeholder.element.nativeElement;
    let parent = phElement.parentElement;

    phElement.style.display = 'none';

    parent.removeChild(phElement);
    parent.appendChild(phElement);
    parent.insertBefore(this.source.element.nativeElement, parent.children[this.sourceIndex]);

    this.target = null;
    this.source = null;

    if (this.sourceIndex != this.targetIndex)
      this.moved.emit({ sourceIdx: this.sourceIndex, targetIdx: this.targetIndex });

    this.activeContainer = null;

    this.listGroup._items.forEach(dropList => {
      let dlRef = (dropList._dropListRef as any);

      if (dlRef._sortStrategy._activeDraggables == undefined)
        dlRef._sortStrategy._activeDraggables = [];

      dlRef._reset();
    });
  }

  enter = (drag: CdkDrag, drop: CdkDropList) => {
    if (this.bypassEnterCheck || drop == this.placeholder)
      return true;

    if (this.activeContainer == null)
      return true;

    if (drop != this.activeContainer)
      return false;

    let phElement = this.placeholder.element.nativeElement;
    let sourceElement = drag.dropContainer.element.nativeElement;
    let dropElement = drop.element.nativeElement;

    let dragIndex = this.__indexOf(dropElement.parentElement.children, (this.source ? phElement : sourceElement));
    let dropIndex = this.__indexOf(dropElement.parentElement.children, dropElement);

    if (!this.source) {
      this.sourceIndex = dragIndex;
      this.source = drag.dropContainer;

      phElement.style.width = sourceElement.clientWidth + 'px';
      phElement.style.height = sourceElement.clientHeight + 'px';

      sourceElement.parentElement.removeChild(sourceElement);
    }

    this.targetIndex = dropIndex;
    this.target = drop;

    phElement.style.display = '';
    dropElement.parentElement.insertBefore(phElement, (dropIndex > dragIndex
      ? dropElement.nextSibling : dropElement));

    this.bypassEnterCheck = true;
    this.placeholder._dropListRef.enter(drag._dragRef, drag.element.nativeElement.offsetLeft, drag.element.nativeElement.offsetTop);
    this.bypassEnterCheck = false;

    return false;
  }

  dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach(dropList => {
      if (this.__isInsideDropListClientRect(dropList, point.x, point.y)) {
        this.activeContainer = dropList;
        return;
      }
    });
  }

  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    const point = this.__isTouchEvent(event) ? (event.touches[0] || event.changedTouches[0]) : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top
    };
  }

  __indexOf(collection, node) {
    return Array.prototype.indexOf.call(collection, node);
  };

  __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
    return event.type.startsWith('touch');
  }

  __isInsideDropListClientRect(dropList: CdkDropList, x: number, y: number) {
    const { top, bottom, left, right } = dropList.element.nativeElement.getBoundingClientRect();
    return y >= top && y <= bottom && x >= left && x <= right;
  }
}
